const PREFIX = 'USERLIST_';

const stocklistConstants = {
  USER_LIST_REQUEST: PREFIX + 'USER_LIST_REQUEST',
  USER_LIST_SUCCESS: PREFIX + 'USER_LIST_SUCCESS',
  USER_LIST_FAILURE: PREFIX + 'USER_LIST_FAILURE',

  SET_VIEWING_USER: PREFIX + 'SET_VIEWING_USER',
};

export default stocklistConstants;
